import { motion } from "framer-motion";
import { Users, CheckCircle } from "@phosphor-icons/react";
import { IMAGES } from "../data";
import { useLang } from "../i18n/LanguageContext";

export default function About() {
  const { t } = useLang();
  const a = t.about;
  return (
    <section id="ueber-uns" data-testid="about-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <div className="overflow-hidden rounded-3xl border border-gray-200">
            <img src={IMAGES.team} alt={a.title} className="w-full h-[440px] object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-2 sm:right-6 bg-[#1e2a6e] rounded-2xl px-7 py-5 shadow-xl">
            <Users size={30} weight="duotone" className="text-[#4a90d9] mb-1" />
            <div className="font-heading text-white font-bold text-lg leading-tight">{a.badge}</div>
          </div>
        </motion.div>

        <div>
          <span className="font-accent text-xs tracking-[0.2em] uppercase font-bold text-[#4a90d9]">
            {a.overline}
          </span>
          <h2 className="font-heading text-3xl sm:text-5xl font-bold tracking-tight text-[#0A0D1F] mt-4">
            {a.title}
          </h2>
          <p className="text-base sm:text-lg text-[#5C6479] mt-5 leading-relaxed">{a.text}</p>

          <div className="mt-8 space-y-3">
            {a.points.map((p) => (
              <div key={p} className="flex items-start gap-3">
                <CheckCircle size={22} weight="fill" className="text-[#4a90d9] shrink-0 mt-0.5" />
                <span className="text-[#0A0D1F] font-medium">{p}</span>
              </div>
            ))}
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4 border-t border-gray-200 pt-8">
            {a.stats.map((s) => (
              <div key={s.label} data-testid="about-stat">
                <div className="font-heading text-3xl sm:text-4xl font-black text-[#1e2a6e]">{s.value}</div>
                <div className="text-xs sm:text-sm text-[#5C6479] mt-1 leading-snug">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
